import React from "react";
import {Circle} from "react-google-maps";


class Location extends React.Component {
  onClick = () => {
    if (this.props.onClick !== undefined) {
      this.props.onClick(this.props.options);
    }
  };

  render() {
    return <Circle {...this.props} onClick={this.onClick} />;
  }
}

export default Location;